//import Stepper from '@material-ui/core/Stepper';
//import Step from '@material-ui/core/Step';
//import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import MapChart from './MapChart';
import utils from "../utils"

function getFlightTimes(flightInfo){
 let { 
    scheduled_out,
    //scheduled_off,
    //scheduled_on,
    scheduled_in,
    estimated_out,
    estimated_off,
    estimated_on,
    estimated_in,
    actual_out,
    actual_off,
    actual_on,
    actual_in
  } = flightInfo


    let take_off = null 
    let take_on = null
    //let ago_day = null
    let ago_hour = null
    let ago_minutes = null
    let departure_based_on = ""
    let arrival_based_on = ""
  
    /*
  if(actual_off){
    take_off = actual_off
    departure_based_on = "Actual"
  }else if(estimated_off){
    take_off = estimated_off
    departure_based_on = "Estimated"
  }else if(scheduled_off){
    take_off = scheduled_off
    departure_based_on = "Schedule"
  }

  if(actual_on){
    take_on = actual_on
    arrival_based_on = "Actual"
  }else if(estimated_on){
    take_on = estimated_on
    arrival_based_on = "Estimated"
  }else if(scheduled_on){
    take_on = scheduled_on
    arrival_based_on = "Schedule"
  }
*/

  if(actual_out){
    take_off = actual_out
    departure_based_on = "Actual"
  }else if(actual_off){
     take_off = actual_off
    departure_based_on = "Actual"
  }else if(estimated_out){
    take_off = estimated_out
    departure_based_on = "Estimated"
  }else if(estimated_off){
    take_off = estimated_off
    departure_based_on = "Estimated"
  }else if(scheduled_out){
    take_off = scheduled_out
    departure_based_on = "Schedule"
  }

  if(actual_in){
    take_on = actual_in
    arrival_based_on = "Actual"
  }else if(actual_on){
    take_on = actual_on
    arrival_based_on = "Actual"
  }else if(estimated_in){
    take_on = estimated_in
    arrival_based_on = "Estimated"
  }else if(estimated_on){
    take_on = estimated_on
    arrival_based_on = "Estimated"
  }else if(scheduled_in){
    take_on = scheduled_in
    arrival_based_on = "Schedule"
  }

  if(actual_in || actual_on){
    
    let now = new Date()
    let actual = actual_in || actual_on
    
    actual = new Date(actual)

    let ago_time = now.getTime() - actual.getTime()
    let ago_to_hour = ago_time/(1000*60*60)
    ago_hour = Math.floor(ago_to_hour)
    ago_minutes = parseInt((ago_to_hour - Math.floor(ago_to_hour))*60)
    //ago_day = ago_hour >= 24 ? Math.floor(ago_hour/24) : 0

  }


  return {
    take_off : take_off,
    take_on : take_on,
    departure_based_on : departure_based_on,
    arrival_based_on : arrival_based_on,
    ago_hour : ago_hour,
    ago_minutes : ago_minutes
  }

}
var StepMiddleIcon = (props) => <span>{utils.ICONS.plane}</span>

var StepLandingIcon= (props) => <span>{utils.ICONS.arrival}</span>
 
var StepTakeoffIcon= (props) => <span>{utils.ICONS.take_off}</span>

const FlightMap = (props) => {
 
  let {flightInfo, stations, show} = props;

  if(!show || !stations || !flightInfo)
    return <></>
  
  let {
    flight_number,
    aircraft_type,
    origin, 
    destination,
    status,
    actual_on,
    actual_in,
    last_position
  } = flightInfo


  if(!origin || !destination )
  return <></>

  let origin_iata = origin ? origin.code_iata : null
  let dest_iata = destination ? destination.code_iata : null

  let origin_ = stations.filter((s) => s.station_code === origin_iata)[0];
  let destination_ = stations.filter((s) => s.station_code === dest_iata)[0];

  let departure_hour_utc = null;
  let departure_hour = null;
  let departure_minute = null;
  let arrival_hour_utc = null;
  let arrival_hour = null;
  let arrival_minute = null;

  let {take_off, take_on, departure_based_on, arrival_based_on, ago_hour, ago_minutes} = getFlightTimes(flightInfo)

  let status_text = status.toLowerCase()
  let status_style = {
    color : status && (status_text.includes("on time") || status_text.includes("arrived")  ) ? "green" : "red"
  }

  if(take_off){
    
    let departure_date = new Date(take_off)
    departure_minute = departure_date.getUTCMinutes();
    departure_hour_utc = departure_date.getUTCHours() 
    departure_hour = departure_hour_utc + ((origin_?.utc_diff || 0)/60) ; //Local hour
  
    if(departure_hour > 23){
      departure_hour = departure_hour - 24
    }

    if(departure_hour < 0){
      departure_hour = 24 + departure_hour
    }

  }

  if(take_on){
    
    let arrival_date = new Date(take_on)
    arrival_minute = arrival_date.getUTCMinutes();
    arrival_hour_utc = arrival_date.getUTCHours();
    arrival_hour = arrival_hour_utc + ((destination_?.utc_diff || 0)/60);
    
    if(arrival_hour > 23){
      arrival_hour = arrival_hour - 24
    }

    if(arrival_hour < 0){
      arrival_hour =  24 + arrival_hour 
    }
              
  }
  
  let current_hour = new Date().getUTCHours();
  let current_minute = new Date().getUTCMinutes()

  let elapsed = current_minute - departure_minute >= 0 ? current_hour - departure_hour_utc : current_hour - departure_hour_utc - 1   ;
  let elapsed_minute = current_minute - departure_minute >= 0 ? current_minute - departure_minute : 60 + current_minute - departure_minute;
  
  let remaining = arrival_minute - current_minute >= 0 ? arrival_hour_utc - current_hour : arrival_hour_utc - current_hour - 1   ;
  let remaining_minute = arrival_minute - current_minute >= 0 ? arrival_minute - current_minute : 60 + arrival_minute - current_minute;
  remaining_minute = remaining < 0 ? 0 : remaining_minute;

  let totalFlight = arrival_minute - departure_minute >= 0 ? arrival_hour_utc - departure_hour_utc : arrival_hour_utc - departure_hour_utc - 1   ;
  let totalFlight_minute = arrival_minute - departure_minute >= 0 ? arrival_minute - departure_minute : 60 + arrival_minute - departure_minute;

  if(departure_hour_utc > arrival_hour_utc){
    totalFlight = arrival_minute - departure_minute >= 0 ? (arrival_hour_utc + 24) - departure_hour_utc : (arrival_hour_utc + 24) - departure_hour_utc - 1   ;
    totalFlight_minute = arrival_minute - departure_minute >= 0 ? arrival_minute - departure_minute : 60 + arrival_minute - departure_minute;
  }
  
  arrival_hour = arrival_hour >= 10 ? arrival_hour : "0" + arrival_hour
  arrival_minute = arrival_minute >= 10 ? arrival_minute : "0" + arrival_minute
  departure_hour = departure_hour >= 10 ? departure_hour : "0" + departure_hour
  departure_minute = departure_minute  >= 10 ? departure_minute : "0" + departure_minute
  elapsed = elapsed > 0 ? (elapsed >= 10 ? elapsed : "0" + elapsed ) + "h" : ""
  elapsed_minute = elapsed_minute > 0 ? (elapsed_minute >= 10 ? elapsed_minute : "0" + elapsed_minute) + "min" : ""
  remaining = remaining > 0 ? (remaining >= 10 ? remaining : "0" + remaining) + "h" : ""
  remaining_minute = remaining_minute > 0 ? (remaining_minute >= 10 ? remaining_minute : "0" + remaining_minute ) +  "min" : ""
  totalFlight = totalFlight > 0 ? (totalFlight >= 10 ? totalFlight : "0" + totalFlight) + "h" : ""
  totalFlight_minute = totalFlight_minute > 0 ? (totalFlight_minute >= 10 ? totalFlight_minute : "0" + totalFlight_minute) +  "min" : ""
  ago_hour = ago_hour > 0 ? (ago_hour >= 10 ? ago_hour : "0" + ago_hour) + "h" : ""
  ago_minutes = ago_minutes > 0 ? (ago_minutes >= 10 ? ago_minutes : "0" + ago_minutes) + "min" : ""

    
    return(
     <section  id="flight_map"> 
      <div className="card secondary flight_map"  style={{ color : "white"}}> 
        <h3>Flight Map</h3> 
        
        <p style={{ color : "white"}}> 
          <Stepper  id = "stepper_flight_map" activeStep={1}  alternativeLabel>
            
            <Step key={1}>
              <StepLabel  StepIconComponent={StepTakeoffIcon}> 
                <p>

                  Departed from <strong>{origin.code_iata}</strong> ({origin.city})
        
                  <br />

                  {departure_based_on ? departure_based_on : ""} <strong>{departure_hour}:{departure_minute} (LT)</strong>      
                  
                  <br /> 
                  
                  <strong> 
                     {actual_in || actual_on || !last_position?  null : elapsed + " " + elapsed_minute + " elapsed"}
                  </strong> 
                </p> 
              </StepLabel>
            </Step>

            <Step key={2}>
              <StepLabel StepIconComponent={StepMiddleIcon}>
                <p>
                  <strong>{flight_number}</strong> {aircraft_type}
                  <br/>  
                  <strong> 
                    {totalFlight} {totalFlight_minute} total flight time
                  </strong>  

                  <br/>

                  <strong><p style={status_style}>{status} {ago_hour} {ago_minutes ? ago_minutes + " ago" : ""}</p></strong>      
                      
                  </p>
                  </StepLabel>
            </Step>

            <Step key={3}>
              <StepLabel StepIconComponent={StepLandingIcon}>
                <p>  
                  Arrival in <strong>{destination.code_iata}</strong> ({destination.city})
                  
                  <br/>
                  
                  {arrival_based_on ? arrival_based_on : ""} <strong>{arrival_hour}:{arrival_minute} (LT)</strong>      
    
                  <br/> 
                  
                  <strong> 
                    
                    {actual_in || actual_on || !last_position ?  null : remaining + " " + remaining_minute + " remaining"}
                    
                  </strong> 
                        
                </p>
              </StepLabel>
            </Step>
          </Stepper>
        </p>


        <MapChart data = {props} />
  
      </div>
    </section>
   
    )
  
};
export default FlightMap;